import * as types from './mutations-types'

export default {
  [types.CLEAR_ARTICLES](state) {
    state.kb = {
      articles: [],
      hasMore: false,
      scrollId: undefined,
      total: 0
    }
  },
  [types.INCLUDE_ARTICLES](state, articles) {
    state.kb.articles = [...state.kb.articles, ...articles]
  },
  [types.SET_ARTICLES_SCROLL](state, scroll) {
    state.kb.scrollId = scroll
  },
  [types.SET_ARTICLES_TOTAL](state, total) {
    state.kb.total = total
  },
  [types.SET_ARTICLES_HASMORE](state, hasMore) {
    state.kb.hasMore = hasMore
  },
  [types.SET_KB_TYPING](state, payload) {
    state.kbTyping = payload
  },
  [types.SET_KB_LOADER](state, payload) {
    state.kbSearchLoader = payload
  },
  [types.SET_KB_SEARCH_RESULT](state, payload) {
    state.kbSearchResult = payload
  },
  [types.SET_CURRENT_ARTICLE](state, value) {
    state.currentArticle = value
  },
  [types.SET_IS_CURRENT_ARTICLE_LOADING](state, value) {
    state.isCurrentArticleLoading = value
  }
}
